var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_23994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.334 15.3335H18.6673C16.8264 15.3335 15.334 16.8259 15.334 18.6668V25.3335C15.334 27.1744 16.8264 28.6668 18.6673 28.6668H25.334C27.1749 28.6668 28.6673 27.1744 28.6673 25.3335V18.6668C28.6673 16.8259 27.1749 15.3335 25.334 15.3335Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 24.5C23.3807 24.5 24.5 23.3807 24.5 22C24.5 20.6193 23.3807 19.5 22 19.5C20.6193 19.5 19.5 20.6193 19.5 22C19.5 23.3807 20.6193 24.5 22 24.5Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.75 18.25V18.251",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_23994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.ce489c09aae4ae507eb2787328ddad16.svg";
export { ForwardRef as ReactComponent };